import { render } from "./NotificationList.vue?vue&type=template&id=aeb48e12&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"

import "./NotificationList.vue?vue&type=style&index=0&id=aeb48e12&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb48e12"]])

export default __exports__